Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetEmailsFromString = void 0;
var _EmailRegex = require("../EmailRegex");
var GetEmailsFromString = exports.GetEmailsFromString = function GetEmailsFromString(value) {
  var emails = value.split(/\n/).map(function (email) {
    return email.trim();
  }).filter(function (email, index, array) {
    return /\S/.test(email) && array.indexOf(email) === index;
  });
  var isValid = emails.length === 0 ? false : true;
  var row = 0;
  for (; row < emails.length; row++) {
    var email = emails[row];
    if (!email || _EmailRegex.EmailRegex.test(email) === false) {
      isValid = false;
      break;
    }
  }
  return {
    emails: emails,
    row: row,
    isValid: isValid
  };
};